// enums.js

export const DifficultyLevel = Object.freeze({
    EASY: 'easy',
    MEDIUM: 'medium',
    HARD: 'hard',
});

export const QuestionStatus = Object.freeze({
    VERIFIED: 'verified',
    UNVERIFIED: 'unverified',
    REJECTED: 'rejected',
});
